<template>
  <draggable-dialog
    v-model:visible="visible"
    top="6vh"
    draggable
    :modal="false"
    destroy-on-close
    :show-close="true"
    :close-on-click-modal="false"
    modalPenetrable
    append-to-body
    @closed="reset"
  >
    <template #header>
      预览图片<span style="margin-left: 5px;color: #999999;font-size: 15px;">{{index + 1}}/{{urlList.length}}</span>
    </template>
    <div class="imgPreviewer-wrap">
      <div class="imgPreviewer-img">
        <el-image
          style="
            width: 100%;
            height: 100%;
            cursor: all-scroll;
            position: relative;
            user-select: none;
          "
          :style="{
            transform: `scale(${scaleRate}) translate(${translateX}px, ${translateY}px)`,
            transition: `${isDrag ? 'none' : 'transform 0.2s'}`,
          }"
          :src="urlList[index]"
          fit="contain"
          @mousedown="mouseDown"
          @wheel="wheel"
        />
      </div>
      <div class="imgPreviewer-tools">
        <el-button
          icon="Back"
          circle
          :disabled="stepDisabled"
          @click="stepNext(-1)"
        />
        <el-button
          icon="Right"
          circle
          :disabled="stepDisabled"
          @click="stepNext(1)"
        />
        <el-button icon="ZoomIn" circle @click="scaleNext(1)" />
        <el-button icon="ZoomOut" circle @click="scaleNext(0)" />
        <el-button icon="RefreshRight" circle @click="reset" />
      </div>
    </div>
  </draggable-dialog>
</template>

<script setup>
import DraggableDialog from "@/components/OnlineWps/draggableDialog.vue";
const visible = defineModel("visible", { type: Boolean, default: false });

const props = defineProps({
  urlList: {
    type: Array,
    required: true,
    default: () => [],
  },
  initialIndex: {
    type: Number,
    required: true,
    default: 0,
  },
});

const index = ref(0);

watch(
  () => props.urlList,
  () => {
    reset();
  },
  {
    deep: true,
  }
);

watch(
  () => props.initialIndex,
  () => {
    index.value = props.initialIndex;
  }
);

watch(
  () => index.value,
  () => {
    reset();
  }
);

const stepDisabled = computed(() => {
  return props.urlList.length <= 1;
});

const stepNext = (step) => {
  let s = index.value + step;
  if (s < 0) {
    s = props.urlList.length - 1;
  }

  if (s > props.urlList.length - 1) {
    s = 0;
  }

  index.value = s;
};

const scaleRateInit = 1;
const scaleRate = ref(scaleRateInit);
const scaleStep = 0.2;
const scaleStepMax = 3;
const scaleStepMin = 0.5;
const scaleNext = (type) => {
  // 1 放大 0 缩小
  scaleRate.value =
    type == 0
      ? Math.max(scaleRate.value - scaleStep, scaleStepMin)
      : Math.min(scaleRate.value + scaleStep, scaleStepMax);
};

const translateX = ref(0);
const translateY = ref(0);
const translateXData = ref(0);
const translateYData = ref(0);
const pageX = ref(0);
const pageY = ref(0);
const isDrag = ref(false);
const mouseDown = (e) => {
  e.preventDefault();
  e.stopPropagation();

  pageX.value = e.pageX;
  pageY.value = e.pageY;
  isDrag.value = true;
};

document.addEventListener("mousemove", mouseMove, false);
document.addEventListener("mouseup", mouseUp, false);

function mouseMove(e) {
  if (isDrag.value) {
    translateX.value =
      translateXData.value + (e.pageX - pageX.value) / scaleRate.value;
    translateY.value =
      translateYData.value + (e.pageY - pageY.value) / scaleRate.value;
  }
}

function mouseUp() {
  isDrag.value = false;
  translateXData.value = translateX.value;
  translateYData.value = translateY.value;
}

const wheel = (e) => {
  e.preventDefault();
  e.stopPropagation();

  // 大于 0 小于 -
  scaleRate.value =
    e.deltaY > 0
      ? Math.max(scaleRate.value - scaleStep, scaleStepMin)
      : Math.min(scaleRate.value + scaleStep, scaleStepMax);
};

const reset = () => {
  scaleRate.value = scaleRateInit;
  translateX.value = 0;
  translateY.value = 0;
  translateXData.value = 0;
  translateYData.value = 0;
};

onBeforeUnmount(() => {
  document.removeEventListener("mousemove", mouseMove);
  document.removeEventListener("mouseup", mouseUp);
});
</script>

<style lang="scss" scoped>
.imgPreviewer-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .imgPreviewer-img {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .imgPreviewer-tools {
    padding-top: 10px;
    flex: 0 0 auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
